// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationMessages_notification__16NUd"};